import { ReactNode } from 'react'

import { BUTTON_TYPES } from '@/types/components'

import { LoadingDots } from '../icons/LoadingDots'

const buttonVariant: Record<BUTTON_TYPES, string[]> = {
  [BUTTON_TYPES.PRIMARY]: ['bg-primary', 'text-white', 'bg-button-pattern', 'bg-cover', 'bg-no-repeat'],
  [BUTTON_TYPES.SECONDARY]: ['bg-primary-light', 'text-primary']
}

type ButtonProps = {
  id?: string
  tabIndex?: number
  disabled?: boolean
  type?: BUTTON_TYPES
  onClick?: () => void
  children: ReactNode
  customClassName?: string
  'data-testid'?: string
  custom?: boolean
  loading?: boolean
}

export const Button = ({
  id,
  tabIndex,
  disabled,
  type = BUTTON_TYPES.PRIMARY,
  onClick,
  children,
  customClassName = '',
  'data-testid': dataTestId,
  custom,
  loading
}: ButtonProps) => {
  return (
    <button
      id={id}
      data-testid={dataTestId}
      tabIndex={tabIndex}
      disabled={disabled}
      className={`w-full rounded-md p-5 text-base font-bold uppercase shadow-strong focus-within:outline-primary disabled:opacity-50 ${
        !custom && buttonVariant[type].join(' ')
      } ${customClassName}`}
      onClick={onClick}
    >
      {loading ? <LoadingDots id="button" customClassName="mx-auto h-6" /> : children}
    </button>
  )
}
